// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2yudY","info":"PatientInfo_info__3G7_K"};